<app-gis-fields [detectedFieldsLayerEnabled]="true"></app-gis-fields>

